import { render, staticRenderFns } from "./POSPrinter.vue?vue&type=template&id=99a9fb36&"
import script from "./POSPrinter.vue?vue&type=script&lang=js&"
export * from "./POSPrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports